import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalJiraRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator',
	path: '/jira/issues/:issueKey?',
};
